import { render } from "./CashierInvoices.vue?vue&type=template&id=a904c798"
import script from "./CashierInvoices.vue?vue&type=script&lang=js"
export * from "./CashierInvoices.vue?vue&type=script&lang=js"

import "./CashierInvoices.vue?vue&type=style&index=0&id=a904c798&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__